import { Link } from "react-router-dom";
import { ArrowUpRight } from "@phosphor-icons/react";
import * as PhosphorIcons from "@phosphor-icons/react";

export default function ServiceCard({ service, featured = false }) {
    const Icon = PhosphorIcons[service.icon] || PhosphorIcons.Ruler;
    return (
        <Link
            to={`/services/${service.slug}`}
            data-testid={`service-card-${service.slug}`}
            className={`tech-card block p-6 md:p-7 group ${featured ? "md:col-span-2 md:row-span-2" : ""}`}
            onMouseMove={(e) => {
                const r = e.currentTarget.getBoundingClientRect();
                e.currentTarget.style.setProperty("--mx", `${e.clientX - r.left}px`);
                e.currentTarget.style.setProperty("--my", `${e.clientY - r.top}px`);
            }}
        >
            <div className="flex items-start justify-between mb-4">
                <div
                    className="w-11 h-11 rounded-lg flex items-center justify-center"
                    style={{
                        background: "linear-gradient(135deg, rgba(6,182,212,0.18), rgba(59,130,246,0.12))",
                        border: "1px solid rgba(6,182,212,0.35)",
                    }}
                >
                    <Icon size={22} weight="duotone" className="text-cyan-300" />
                </div>
                <ArrowUpRight
                    size={20}
                    className="text-slate-500 group-hover:text-cyan-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all"
                />
            </div>
            <h3 className="font-heading text-xl font-semibold text-slate-50 mb-2">{service.name}</h3>
            <p className="text-sm text-slate-400 leading-relaxed">{service.short}</p>
            {featured && service.description && (
                <p className="text-sm text-slate-500 leading-relaxed mt-3">{service.description}</p>
            )}
            <div className="mt-5 flex items-center gap-3 text-xs font-mono-alt text-slate-500">
                <span className="text-cyan-400">DWG</span>
                <span className="dot-divider" />
                <span>Civil 3D / AutoCAD</span>
            </div>
        </Link>
    );
}
